import { getAccessTokenFromCookie } from "../util/authentication";

export const kronosTimecard = async (eID, payPeriod) => {
    const apiEndpoint = process.env.REACT_APP_KRONOS_API + "timecard/";
    const response = await fetch((apiEndpoint + eID + "/" + payPeriod),{
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
}
